import { motion } from 'framer-motion';
import { Briefcase } from "lucide-react";

const experienceData = [
    {
        role: "Co-Creator",
        company: "Bengal",
        duration: "February 2025 - Present",
        desc: "A platform for building and orchestrating simple and secure AI Agents",
        tech: "OpenAI, Node.js, React, Python, FastAPI, AWS",
        url: "https://buildwithbengal.com"
    },
    {
        role: "Fuel Associate",
        company: "Wawa",
        duration: "September 2024 - Present",
        desc: "Assisting customers with fuel needs",
    }
];

function Experience() {
    return (
        <div className="py-12 bg-gray-50">
            <div className="max-w-5xl mx-auto px-4">
                <h2 className="text-3xl font-bold mb-8 flex items-center gap-2">
                    <Briefcase /> Experience
                </h2>
                <div className="flex flex-col space-y-8">
                    {experienceData.map((exp, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="p-4 bg-white rounded-2xl shadow-md"
                        >
                            <h3 className="text-xl font-semibold mb-2">{exp.role} @ {exp.company}</h3>
                            <p className="text-gray-600 mb-1">{exp.duration}</p>
                            <p className="text-gray-700">{exp.desc}</p>
                            { exp.tech && <p><em>Tech Stack: {exp.tech}</em></p> }
                            { exp.url && <a href={exp.url} className="text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer">{exp.url}</a> }
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Experience;